



















































































import { computed, defineComponent, ref } from "@vue/composition-api";
import { isVideoFile } from "@/lib/fileHelpers";
import { MediaFilesController } from "@/lib/MediaFilesController";
import { getMediaDuration } from "@/lib/time";
import { UploadVaultFile } from "@/types";
import BaseDownloadButton from "@/components/BaseDownloadButton";
import BaseIcon from "@/components/BaseIcon";
import BaseImage from "@/components/BaseImage";
import FullScreen from "@/components/FullScreen";
import PlayButton from "@/components/PlayButton";

export default defineComponent({
  name: "VaultFileItemWithPreview",
  components: { BaseDownloadButton, FullScreen, BaseImage, BaseIcon, PlayButton },
  props: {
    isLoading: { type: Boolean, default: false },
    thumbnails: { type: Boolean, default: false },
    fileClasses: { type: Array as () => Record<string, string>[] },
    file: { type: Object as () => UploadVaultFile, required: true },
    isFileUsed: { type: Boolean, default: false },
    canDownload: { type: Boolean, default: false },
  },
  setup(props) {
    const isVideoStarted = ref(false);
    const isVideo = computed<boolean>(() => isVideoFile(props.file));
    const videoSrc = computed<string>(() =>
      isVideo.value ? MediaFilesController.getVideoUrl(props.file.urlPart) : ""
    );
    const onPlayVideo = () => {
      isVideoStarted.value = true;
    };

    const icon = computed(() => (isVideo.value ? "sci-video" : "sci-image"));
    const isZoomable = computed<boolean>(() => !isVideo.value && !isVideoStarted.value);
    const getVaultDuration = computed<string | null>(() =>
      props.file.metadata.duration ? getMediaDuration(Number(props.file.metadata.duration)) : null
    );

    const vaultFileSrc = (width: "360p" | "1080p" = "360p") => {
      if (!props.file.urlPart) return "";
      return isVideo.value
        ? MediaFilesController.getVideoThumbnail(props.file.urlPart, width)
        : MediaFilesController.getImageThumbnail(props.file.urlPart, width);
    };

    const fileUrl = computed(() => MediaFilesController.getFileUrl(props.file.urlPart));
    const fileName = computed(() => props.file.metadata.filename);

    const isBottomRightIcon = computed<boolean>(() => !props.thumbnails && isVideo.value && !!getVaultDuration.value);
    const isCentralIcon = computed(() => !props.thumbnails && isVideo.value);
    const isBottomLeftIcon = computed(() => !props.thumbnails && props.isFileUsed);
    const isTopRightIcon = computed(() => !props.thumbnails && !!props.fileClasses);

    return {
      icon,
      isVideo,
      videoSrc,
      fileUrl,
      fileName,
      isZoomable,
      vaultFileSrc,
      isVideoStarted,
      getVaultDuration,
      isCentralIcon,
      isTopRightIcon,
      isBottomLeftIcon,
      isBottomRightIcon,
      onPlayVideo,
    };
  },
});
